import React, { useEffect, useState } from "react";
import NavBar from "../Components/NavBar";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import { getDocs, collection, query } from "firebase/firestore";
import { firestore } from "../Firebase/config";

export default function Home() {
  const [reports, setReports] = useState([]);
  const userId = useSelector((state) => state.user.user.docId);

  const customStyles = {
    rows: {
      style: {
        minHeight: '56px', // Adjust the row height as needed
      },
    },
    headRow: {
      style: {
        backgroundColor: '#f2f2f2', // Change the background color of header row
      },
    },
    headCells: {
      style: {
        paddingLeft: '8px', // Adjust the padding of header cells
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px', // Adjust the padding of cells
        paddingRight: '8px',
      },
    },
  };

  const getReportData = async () => {
    const q = query(collection(firestore, `users/${userId}/report`));

    const docRef = await getDocs(q);
    const data = docRef.docs.map((item) => item.data());
    // console.log(data);
    setReports(data);
    // console.log(docRef.docs)
  };

  useEffect(() => {
    getReportData();
  }, []);


  const keys = Object.keys({ ...reports[0] });



  const columns = keys.map((key) => ({
    name: `${key}`,
    selector: (row) =>
      row[key] === true ? (
        <i class="ri-check-fill"></i>
      ) : (
        row[key] === false ? <i class="ri-close-large-line"></i> :
        row[key]
      ),
  }));

  const data = reports.map((item) => {
    return { ...item };
  });

  // console.log(data);
  

  return (
    <>
      <NavBar />

      <h1 className="text-center my-5 text-3xl font-bold "> Report History</h1>

      <DataTable columns={columns} data={data} customStyles={customStyles} className="custom-datatable" />
    </>
  );
}
